/// src/api/context/UserSessionContext.tsx
import React, { createContext, useState, ReactNode } from "react";
import { User } from "../api/contracts/userTypes";
import { SessionDevice } from "../api/contracts/deviceTypes";

// ----------------------
// Types
// ----------------------
export type UserSessionContextType = {
  user: User | null;
  devices: SessionDevice[];
  setUser: (user: User | null) => void;
  setDevices: (devices: SessionDevice[]) => void;
};

// ----------------------
// Context
// ----------------------
export const UserSessionContext = createContext<UserSessionContextType>({
  user: null,
  devices: [],
  setUser: () => {},
  setDevices: () => {},
});

// ----------------------
// Provider
// ----------------------
type Props = {
  children: ReactNode;
};

export const UserSessionProvider: React.FC<Props> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [devices, setDevices] = useState<SessionDevice[]>([]);

  return (
    <UserSessionContext.Provider value={{ user, devices, setUser, setDevices }}>
      {children}
    </UserSessionContext.Provider>
  );
};
